<template>
  <div class="wellknown-service">
    <div class="wellknown-service_main">
      <div class="title">企业出海人力资源服务</div>
      <nuxt-link to="/" class="back-to-home">返回官网首页</nuxt-link>
      <div class="list">
        <nuxt-link v-for="item in json" :key="item.name" :to="item.url" class="item">
          <div class="header">
            <div class="icon" :style="{ backgroundImage: `url(${icons[`/assets/icons/services/${item.name}.svg`].default})` }"></div>
            <h1>{{ item.title }}</h1>
            <div class="link">详情</div>
          </div>
          <div class="body">{{ item.content }}</div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import json from '@/assets/contents/wellknown-service.json';
const icons = import.meta.glob('@/assets/icons/services/*.svg', { eager: true }) as unknown as Record<string, { default: string }>;
</script>
<style lang="less" scoped>
.wellknown-service {
  height: 520px;
  background: url("https://video.reta-inc.com/image/default/10A7960C57A34C11B8B9558DDFDC1814-6-2.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  a {
    text-decoration: none;
  }
  &_main {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 34px;
      color: #1D2129;
      text-align: center;
      padding-top: 30px;
    }
  }
  .back-to-home {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4E5969;
    position: absolute;
    right: 0;
    top: 30px;
  }
  .list {
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    .item {
      display: block;
      width: calc(33.33% - 16px);
      height: 188px;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid #FFFFFF;
      backdrop-filter: blur(10px);
      border-radius: 8px;
      padding: 22px 24px 24px;
      box-sizing: border-box;
      &:hover {
        background: rgba(255, 255, 255, 0.6);
        border: 1.5px solid #386AFF;
        box-shadow: 0px 4px 16px rgba(149, 149, 150, 0.2);
        backdrop-filter: blur(10px);
      }
      .header {
        display: flex;
        align-items: center;
        .icon {
          width: 30px;
          height: 30px;
        }
        h1 {
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          color: #1D2129;
          margin: 0;
          margin-left: 12px;
        }
        .link {
          font-size: 16px;
          line-height: 22px;
          color: #165DFF;
          margin-left: auto;
          display: flex;
          align-items: center;
          &::after {
            display: block;
            content: '';
            width: 16px;
            height: 16px;
            background: url(@/assets/icons/arrow-down-blue.svg) no-repeat;
            background-size: contain;
            margin-left: 2px;
            transform: rotate(-90deg);
          }
        }
      }
      .body {
        margin-top: 8px;
        font-size: 14px;
        line-height: 26px;
        color: #4E5969;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and(max-width:800px) {
  .wellknown-service {
    height: auto;
    padding: 0 20px 20px;
    .wellknown-service_main {
      .back-to-home {
        display: block;
        position: relative;
        margin-top: 20px;
        text-align: center;
        top: 0;
      }
      .list {
        .item {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
